const millisecondsToSeconds = (milli: number) => milli * 1000;

const hoursToMinutes = (hours: number) => hours * 60;

const HelperTime = {
    secondsToMilliseconds: millisecondsToSeconds,
    hoursToMinutes
}

export default HelperTime;